import FullPageTextDisplay from './FullPageTextDisplay';

export default FullPageTextDisplay;
